import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_MeasurementUnit } from './ModuleFE_MeasurementUnit.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_MeasurementUnit,
    modules: [ModuleFE_MeasurementUnit],
    mapper: item => [item.unitAsString],
    placeholder: 'Choose a measurement unit',
    renderer: item => _jsx(_Fragment, { children: item.unitAsString }),
    sortBy: [(item) => item.unitAsString.toLowerCase()]
};
export const DropDown_MeasurementUnit = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_MeasurementUnit,
    itemRenderer: (item, onDelete) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [_jsx(ICONS.x.component, { onClick: onDelete }), item.unitAsString] });
    },
    uiSelector: DropDown_MeasurementUnit.selectable,
});
export const MultiSelect_MeasurementUnit = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map